/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Snackbar, SnackbarCloseReason } from '@mui/material';
import { IVFormErrors, VForm, VTextField, useVForm } from '../../../shared/forms';
import * as yup from 'yup';
import { NfeService } from '../../../shared/services/api/Financeiro/fiscal';
import { Environment } from '../../../shared/environment';
import { TelaBloqueioSalvando } from '../../../shared/components';
import { useBloqueioSalvamento } from '../../../shared/hooks';

interface IFormData {
  xtexto: string;
  nseqevento: number;
}
export interface ConfirmationDialogRawProps {
  id: string;
  open: boolean;
  status: number;
  onClose: (value?: string) => void;
}

const formValidationSchema: yup.ObjectSchema<IFormData> = yup.object().shape({
  xtexto: yup.string().required().min(15),
  nseqevento: yup.number().required(),
});


export const DialogCartaCorrecao: React.FC<ConfirmationDialogRawProps> = (props: ConfirmationDialogRawProps) => {
  const { formRef, save, } = useVForm();
  const { onClose, open, ...other } = props;
  const [isLoading, setIsLoading] = useState(false);
  const { isSaving, progress: saveProgress, iniciar: iniciarSalvamento, concluir: concluirSalvamento, cancelar: cancelarSalvamento } = useBloqueioSalvamento();
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
  };
  const handleSave = (dados: IFormData) => {
    if (!iniciarSalvamento()) return;

    formValidationSchema.
      validate(dados, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);
        NfeService.cartacorrecao(props.id, dadosValidados)
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              cancelarSalvamento();
              setTms('error');
              setMsg(result.message);
              setOpenmsg(true);
            } else {
              concluirSalvamento();
              const blob = new Blob([result], { type: 'application/pdf' });
              const url = URL.createObjectURL(blob);
              window.open(url, '_blank');
              setTimeout(() => URL.revokeObjectURL(url), 10000);
              onClose();
            }
          });
      })
      .catch((errors: yup.ValidationError) => {
        cancelarSalvamento();
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <>
      <TelaBloqueioSalvando
        open={isSaving}
        message="Enviando carta de correção..."
        progress={saveProgress}
      />
      <Dialog
      open={open}
      {...other}
      maxWidth='xl'
    >
      <DialogTitle>Carta de Correção</DialogTitle>
      <DialogContent dividers>
        <VForm ref={formRef} onSubmit={handleSave}placeholder={undefined} onPointerEnterCapture={undefined}onPointerLeaveCapture={undefined}>
          <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={tms === 'error' ? null : 900} onClose={handleCloseMsg}>
            <Alert
              onClose={handleCloseMsg}
              severity={tms}
              variant="filled"
              sx={{ width: '100%' }}
            >
              {msg}
            </Alert>
          </Snackbar>
          <Grid container direction="column" padding={1} >
            <Grid container item direction="row" padding={1} spacing={1}>
              <Grid item xs={10} sm={10} md={10} lg={10} xl={12}>
                <Grid item xs={10} sm={10} md={10} lg={10} xl={3}>
                  <VTextField
                    fullWidth
                    name='nseqevento'
                    label='Sequencia'
                    disabled={isLoading}
                  />
                </Grid>
              </Grid>
              <Grid item xs={10} sm={10} md={10} lg={10} xl={12}>
                <VTextField
                  fullWidth
                  name='xtexto'
                  label='Texto'
                  multiline
                  rows={4}
                  disabled={isLoading}
                />
              </Grid>
            </Grid>
          </Grid>
        </VForm>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' color='error' onClick={handleCancel}>Cancelar</Button>
        <Button variant='outlined' autoFocus disabled={isSaving} onClick={save}>Confirmar</Button>
      </DialogActions>
    </Dialog>
    </>
  );
};